import { FormFieldOption } from "../types";

// file to include helper methods to use in our async search field
export function resetDataHandler(reset: Function, resetCallback?: Function) {
  reset();
  resetCallback?.();
}

export function defaultOptionsMapper(obj: any): FormFieldOption {
  return { label: obj.name, value: obj.id };
}
